module.exports = __webpack_public_path__ + "img/vk.5a9be33.svg?v=1761300065174";